window.addEventListener('load', event => {
    let stickyParents = document.querySelectorAll('.sticky-parent');

    if (stickyParents.length) {
        const horizontalScroll = () => {
            for (let stickyParent of stickyParents) {
                let stickyChild = stickyParent.querySelector('.sticky-child');
                let stickyPosition = stickyChild.getBoundingClientRect().top;

                if (stickyPosition > 100 && !(stickyChild.scrollLeft === 0)) {
                    stickyChild.scrollLeft = 0;
                } else {
                    let scrolled = stickyParent.getBoundingClientRect().top;
                    let scrollDirection = stickyChild.dataset.scrollDirection === 'rtl' ? 1 : -1;
                    let scrollWidth = stickyChild.scrollWidth;
                    let verticalScrollHeight = stickyParent.getBoundingClientRect().height - stickyChild.getBoundingClientRect().height;

                    stickyChild.scrollLeft = (scrollWidth / verticalScrollHeight) * (scrolled) * 0.85 * scrollDirection;
                }
            }
        }
        window.addEventListener('scroll', horizontalScroll);
        window.addEventListener('load', horizontalScroll);
    }
});
